<template>
  <div class="chart-table">
    <div v-if="title" class="m-title">{{ title }}</div>
    <div class="board-box core" v-loading="loading">
      <div class="layui-form layui-card-header layuiadmin-card-header-auto">
        <div class="layui-inline">
          <input type="text" autocomplete="off" class="layui-input" placeholder="请输入查询条件"
            v-model="tableObj.queryObject['WORK_ORDER_NUM:2,BRAND_NAME:2,STORE_NAME:2,MANAGER_NAME:2']"/>
        </div>
        <button class="layui-btn layuiadmin-btn-list" @click="$refs.tId.search()" title="查询">查询</button>
        <button class="layui-btn fold-flag advanced" title="高级搜索" @click="advancedShow = !advancedShow" v-if="tabConfig.searchConfig && tabConfig.searchConfig.advanced.length">高级搜索</button>
        <div style="float: right;">
            <button class="layui-btn refresh" title="刷新列表" @click="$refs.tId.reset();">
              <i class="layui-icon">&#xe669;</i>
              刷 新
            </button>
        </div>
      </div>
      <advanced-query ref="advancedObj" v-if="advancedShow" :tableObj="tableObj" :advanced="tabConfig.searchConfig.advanced" class="advance-wrapper"></advanced-query>
        <layui-table
          v-if="tabConfig.serName"
          :ref="tId"
          :request-unique-id="tabConfig.requestUniqueId"
          :table-name="tabConfig.serName"
          :defaultCondition="tabConfig.condition"
          :page-size="20"
          :page-range="6"
          :page-options="[10, 20, 50, 100]"
          :skin="'line'"
          :height="height"
          :sort="tabConfig.sort"
          :before-load="() => (loading = true)"
          :after-load="() => (loading = false)"
          :renderRow="renderRow"
          @table-event-detail="detail($event.data)"
          @table-event-dispatch="dispatch($event.data)"
          @table-event-ys="accept($event.data)"
        >
          <div>
            <div align="center" title="序号" width="60" fixed="left">
              <script type="text/html" v-pre>
                <div class="layui-btn-xs" lay-event="detail" style="cursor:pointer; display: inline-block; width: 100%;">{{ d.LAY_INDEX }}</div>
              </script>
            </div>
            <layui-tableconfig :config="tabConfig.cols"></layui-tableconfig>
            <div align="center" fixed="right" title="操作" :width="tabConfig.opt">
              <script type="text/html" v-pre>
                <a class=" layui-btn-xs" lay-event="detail" >查看</a>
                {{#  if(d._source.indexOf("workWfp") > -1){ }}
                <a class=" layui-btn-xs" lay-event="dispatch">派单</a>
                {{#  } }}
                 {{#  if(d._source.indexOf("gcDb") > -1){ }}
                <a class=" layui-btn-xs" lay-event="ys">验收</a>
                {{#  } }}
              </script>
            </div>
          </div>
        </layui-table>
    </div>
  </div>
</template>

<script>
import comTable from './mixins/comTable'
/**
 * 表格
 * - 客服面板
 * - 经理面板 jl
 */
export default {
  mixins: [comTable],
  name: 'ChartTable2',
  props: {
    /**
     * 来源
     *
     * - workWfp：未分配服务请求列表
     * - workWwc：未完成服务请求列表
     * - serviceWwc：未完成现场服务单列表
     * - serviceYc： 异常现场服务单列表 客服
     *
     * - gcDb: 工程服务待办： 项目经理、项目总监
     * - ~~workYc： 异常服务请求列表 项目经理、项目总监~~
     * - workYc： 异常现场服务单列表 项目经理、项目总监
     */
    source: { type: String, default: '' },
    height: { type: String, default: '260' }
  },
  components:{
  },
  data() {
    return {
      advancedShow:false,
      tabConfig: {
        serName: '',
        cols: [],
        searchConfig:{
          advanced: []
        }
      },
      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
    }
  },
  mounted() {
    /** @type {import('../index.vue').IRoleId} */
    let roleId = this.roleId
    const baseCol = [
      // { title: '序号', field: 'index', width: 80 },
      { title: '服务请求单编号', field: 'WORK_ORDER_NUM', width: 130 },
      {
        title: '工单类型',
        field: 'WORK_ORDER_CATEGORY_DESC',
        width: 100,
        translateDomain: 'TRNSLATE_WORK_ORDER_CATEGORY'
      },
      { title: '项目经理', field: 'MANAGER_NAME', width: 130 },
      { title: '品牌', field: 'BRAND_NAME', width: 130 },
      { title: '门店', field: 'STORE_NAME', width: 130 },
      { title: '服务商', field: 'SERVICE_NAME', width: 130 }
    ]
    const Map = {
      workWfp: {
        requestUniqueId: `${roleId}_table_2_workWfp`,
        serName: 'YW_WORK_ORDER_DETAIL_V1',
        /**
         * 订单类型
         * - 服务单（现场服务请求）-service
         * - 工单（服务请求）-work
         */
        tableType: 'work',
        condition: {
          // WHERE order_state IN ('1')
          'ORDER_STATE:1': '1'
        },
        opt: '105',//操作列的宽度
        cols: [{ title: '工单状态', field: 'ORDER_STATE_DESC', width: 130}, ...baseCol]
      },
      workWwc: {
        requestUniqueId: `${roleId}_table_2_workWwc`,
        serName: 'YW_WORK_ORDER_DETAIL_V1',
        /**
         * 订单类型
         * - 服务单（现场服务请求）-service
         * - 工单（服务请求）-work
         */
        tableType: 'work',
        condition: {
          /**
           * 未完成服务请求
           * `WHERE order_state IN (1,2,3,4,5) 或者 NOT IN (6)`
           */
          'ORDER_STATE:1': '1,2,3,4,5'
        },
        opt: '60',//操作列的宽度
        cols: [{ title: '工单状态', field: 'ORDER_STATE_DESC', width: 130 }, ...baseCol]
      },
      serviceWwc: {
        requestUniqueId: `${roleId}_table_2_serviceWwc`,
        serName: 'YW_SERVICE_ORDER_V1',
        /**
         * 订单类型
         * - 服务单（现场服务请求）-service
         * - 工单（服务请求）-work
         */
        tableType: 'service',
        condition: {
          // 未完成现场服务请求：除 7-已关闭 外
          // WHERE service_state IN (1,2,3,4,5,6,8,9,10) 或者 NOT IN (7)
          'SERVICE_STATE:1': '1,2,3,4,5,6,8,9,10'
        },
        opt: '60',//操作列的宽度
        cols: [{ title: '服务状态', field: 'SERVICE_STATE_DESC', width: 130 }, ...baseCol]
      },
      serviceYc: {
        requestUniqueId: `${roleId}_table_2_serviceYc`,
        serName: 'YW_SERVICE_ORDER_YICHANG_V1',
        /**
         * 订单类型
         * - 服务单（现场服务请求）-service
         * - 工单（服务请求）-work
         */
        tableType: 'service',
        condition: {
          /**
           * 异常现场服务请求
           * - 视图处理
           */
          // 'SERVICE_STATE:1': ''
        },
        opt: '60',//操作列的宽度
        cols: [{ title: '服务状态', field: 'SERVICE_STATE_DESC', width: 130 },{ title: '异常类型', field: 'E_TYPE', width: 200 }, ...baseCol]
      },

      /**
       * 工程服务待办
       */
      gcDb: {
        requestUniqueId: `${roleId}_table_2_gcDb`,
        serName: 'YW_SERVICE_ORDER_V1',
        /**
         * 订单类型
         * - 服务单（现场服务请求）-service
         * - 工单（服务请求）-work
         */
        tableType: 'service',
        condition: {
          'WORK_ORDER_CATEGORY:0': 2,
          'SERVICE_STATE:0': 5
        },
        opt: '105',//操作列的宽度
        cols: [{ title: '状态', field: 'SERVICE_STATE_DESC', width: 130 }, ...baseCol],
        //定制化高级查询
        searchConfig: {
          advanced: [
            { TYPE:'input', NAME: '品牌 :', FIELD:'BRAND_NAME:2', PLACEHOLDER: '请输入查询条件'},
            { TYPE:'input', NAME: '项目经理 :', FIELD:'MANAGER_NAME:2', PLACEHOLDER: '请输入查询条件'}
          ]
        },
      },
      /**
       * 异常服务请求列表
       */
      workYc: {
        requestUniqueId: `${roleId}_table_2_workYc`,
        serName: 'YW_SERVICE_ORDER_YICHANG_V1',
        /**
         * 订单类型
         * - 服务单（现场服务请求）-service
         * - 工单（服务请求）-work
         */
        tableType: 'service',
        condition: {},
        opt: '60',//操作列的宽度
        cols: [{ title: '工单状态', field: 'ORDER_STATE_DESC', width: 130 },{ title: '异常类型', field: 'E_TYPE', width: 200 }, ...baseCol],
        sort:['YW_SERVICE_ORDER_UPDATE_TIME:DESC']
      }
    }

    this.tabConfig = Map[this.source] || {}

    this.$nextTick(() => {
      this.tableObj = this.$refs.tId;
    })
  },
  methods: {
    renderRow(data){
        data._source = this.source;
    },
  }
}
</script>
<style scoped>
  .layui-inline >>> .layui-icon-date{
    top: -2px !important;
  }
  .layui-card-header.layuiadmin-card-header-auto {
    padding-top: 4px;
    padding-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/ChartTable2.vue